import RequirePcoAuth from './requirePcoAuth';
import ReimbursementForm from '../reimbursement/reimbursementForm';

/**
 * The donation/reimbursement/check request form, gated behind Planning
 * Center login (see requirePcoAuth.js) - the only way to reach it.
 */
const PortalDonationsReimbursementsForm = () => (
  <>
    <RequirePcoAuth />
    <ReimbursementForm />
  </>
);

export default PortalDonationsReimbursementsForm;
